module.exports = __webpack_public_path__ + "img/MARIANA.dae09f25.jpeg";